export const SHARED_WITH_TEAM_FIELD = {
  label: 'Shared with Team',
  offLabel: 'Hidden from Team',
  name: 'is_hidden_from_team',
  type: 'switch',
  icon: 'group',
  isInverted: true,
};

export const SHARED_WITH_TEAM_FIELD_V2 = {
  label: 'Shared With Team',
  offLabel: 'Hidden from Team',
  name: 'Shared With Team',
  data_type: 'switch',
  id: 'is_hidden_from_team',
  isInverted: true,
  icon: '',
};

export const SHARED_WITH_SUB_ACCOUNTS_FIELD_PROFILE_V2 = {
  name: 'Shared With Sub-accounts',
  value: null,
  data_type: 'multi_select',
  id: 'shared_users',
  icon: '',
  options: [],
};

export const SHARED_WITH_SUB_ACCOUNTS_FIELD = {
  label: 'Shared with Sub-accounts',
  name: 'shared_users',
  type: 'multi_select',
  items: [],
  icon: 'group',
  isFavorited: false,
};

export default function(types, statuses, sources, ownerTeamMembers, assignedTeamMembers) {
  return {
    personal: [
      { label: 'First name', name: 'first_name' },
      { label: 'Last name', name: 'last_name' },
    ],
    phones: [
      { label: 'Mobile Phone', name: 'mobile_phone', icon: 'smartphone' },
      { label: 'Home Phone', name: 'home_phone', icon: 'phone' },
      { label: 'Office Phone', name: 'office_phone', icon: 'phone' },
    ],
    misc: [
      { label: 'Birthday', name: 'birthday', type: 'date', icon: 'cake' },
      { label: 'Anniversary', name: 'anniversary', type: 'date', icon: 'cake' },
      { label: 'Spouse Name', name: 'spouse_name', icon: 'person' },
      { label: 'Spouse Email', name: 'spouse_email', icon: 'email' },
      { label: 'Spouse Phone', name: 'spouse_phone', icon: 'phone' },
      { label: 'Spouse Birthday', name: 'spouse_birthday', type: 'date', icon: 'cake' },
      { label: 'Type', name: 'type_id', type: 'select', items: types, icon: 'subject' },
      { label: 'Status', name: 'status', type: 'select', items: statuses, icon: 'info' },
      { label: 'Source', name: 'source_id', type: 'select', items: sources, icon: 'play_for_work' },
      { label: 'Company', name: 'company', icon: 'business' },
      { label: 'Owner', name: 'owner_user_id', type: 'select', items: ownerTeamMembers, icon: 'person' },
      { label: 'Assigned To', name: 'assigned_user_id', type: 'select', items: assignedTeamMembers, icon: 'person' },
      SHARED_WITH_TEAM_FIELD,
      SHARED_WITH_SUB_ACCOUNTS_FIELD,
    ],
  };
}
